import { useParams } from 'react-router-dom';

const useCompanyId = () => {
  const params = useParams() as { companyKey: string };
  return params.companyKey;
};

export default useCompanyId;
